import { Iap, ProductId } from '.';
import { defineActions } from '../utils';
import { asyncAction, ValidatePurchaseArgs } from '@play-co/replicant';
import { getStripePriceIdByProductId } from './iap.util';
import { isProductId } from './iap.util';

export const iapActions = defineActions<Iap>()({
  asyncHandlePurchase: asyncAction(
    async (state, args: ValidatePurchaseArgs, api) => {
      // Validate purchase is not available on web platform
      // const purchaseInfo = await api.purchases.validatePurchase(args);
      // const productId = purchaseInfo.productId as ProductId;
      // const { productIds, prices } = Iap.ruleset;
      // if (!productIds.includes(productId)) {
      //   throw new Error('Unknown product: ' + productId);
      // }

      const productId = (args as any).productId;

      if (!Iap.ruleset.productIds.includes(productId)) {
        throw new Error('Unknown product: ' + productId);
      }

      const rewards = Iap.api.getProductRewards(productId);
      const productPrice = Iap.ruleset.prices[productId];

      Iap.api.claimProductRewards(state, rewards);

      state.lifetimeValue += productPrice;
    },
  ),
  /** Initiates stripe purchase by creating a payment intent */
  asyncCreateStripePaymentIntent: asyncAction(
    async (_, args: { productId: string; liveMode: boolean }, api) => {
      const productId = args.productId as ProductId;
      const priceId = getStripePriceIdByProductId(productId, args.liveMode);
      const result = await api.payments.createPaymentIntent({ priceId });
      return { clientSecret: result.paymentIntent.clientSecret };
    },
  ),

  updatePaymentIntentWithProductId: asyncAction(
    (state, args: { productId: string }, api) => {
      state.checkoutProductId = args.productId;
    },
  ),

  completePaymentIntent: asyncAction(async (state, args, api) => {
    const productId = state.checkoutProductId as ProductId;
    if (!productId) {
      throw new Error('Missing productId during completePaymentIntent');
    }

    const { productIds, prices } = Iap.ruleset;
    if (!productIds.includes(productId)) {
      throw new Error('Unknown product: ' + productId);
    }

    const rewards = Iap.api.getProductRewards(productId);
    const productPrice = prices[productId];

    Iap.api.claimProductRewards(state, rewards);

    state.lifetimeValue += productPrice;
    state.checkoutProductId = undefined;
  }),

  clearPaymentIntent: asyncAction(async (state, args, api) => {
    state.checkoutProductId = undefined;
  }),
});
